import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { selectDiscoverSearch } from '../../../../store/discover/search/discover-search.selectors';

import { selectDaisyTheme } from '../../../../store/themes/themes.selectors';
import DiscoverSubNavigation from '../../../../components/discover/discover-sub-navigation/discover-sub-navigation.component';
import {
    discover_grid,
    discover_page,
    muted_border,
    widget_full,
    widget_half,
} from '../../../../utils/styles/tailwind-styles';

import Widget from '../../../../components/discover/widget/widget.component';

import Admin from '../../../../components/discover/admin/admin.component';
import { REACT_TOUR_CLASS_NAMES } from '../../../../utils/react-tour.util';
import { selectDiscoverRepPageWidgets } from '../../../../store/discover/widgets/widgets.selectors';
import {
    DISCOVER_WIDGET_AGGREGATION_METRICS,
    DISCOVER_WIDGET_DATA_VISUALIZATIONS,
} from '../../../../store/discover/widgets/widgets.types';

import {
    createNotification,
    NOTIFICATION_TYPES,
} from '../../../../utils/notification.util';
import {
    setRepPageWidgets,
    setSkuPageWidgets,
} from '../../../../store/discover/widgets/widgets.actions';
import AddWidget from '../../../../components/discover/widget/add-widget.component';
import NotFound from '../../../../components/not-found/not-found.component';
import { widgetService } from '../../../../store/discover/widgets/widgets.services';
import { objectService } from '../../../../utils/object.util';

const RepPage = () => {
    const params = useParams();
    const dispatch = useDispatch();

    const discoverSearchMaster = useSelector(selectDiscoverSearch);
    const repPageWidgets = useSelector(selectDiscoverRepPageWidgets);
    const daisyTheme = useSelector(selectDaisyTheme);

    const [refresher, setRefresher] = useState(0);

    const [perspective, setPerspective] = useState({});
    const [selectedDate, setSelectedDate] = useState(
        localStorage.getItem('selectedDate') ?? 'MTD'
    );

    const handleAddWidget = (
        metric,
        visualization,
        sortDirection,
        aggregationMetric,
        size
    ) => {
        const widgetData = {
            metric,
            visualization,
            sortDirection:
                visualization === DISCOVER_WIDGET_DATA_VISUALIZATIONS.TREND
                    ? null
                    : sortDirection,
            aggregationMetric,
            size,
        };

        const widgetId = widgetService.createWidgetRuleset(
            widgetData.metric,
            widgetData.visualization,
            widgetData.sortDirection,
            perspective,
            widgetData.aggregationMetric
        );

        let validWidget = true;

        if (Object.keys(repPageWidgets).includes(widgetId)) {
            createNotification(
                'A widget exists on this page which matches those parameters.',
                NOTIFICATION_TYPES.ERROR
            );
            document
                .getElementById(widgetId)
                .scrollIntoView({ behavior: 'smooth', block: 'start' });

            validWidget = false;
        }

        if (validWidget) {
            let newRepPageWidgets = {
                ...repPageWidgets,
            };
            newRepPageWidgets[widgetId] = widgetData;
            dispatch(setRepPageWidgets(newRepPageWidgets));
        }
    };

    const handleRemoveWidget = (
        metric,
        visualization,
        sortDirection,
        aggregationMetric
    ) => {
        const widgetId = widgetService.createWidgetRuleset(
            metric,
            visualization,
            sortDirection,
            perspective,
            aggregationMetric
        );
        let newRepPageWidgets = { ...repPageWidgets };
        if (Object.keys(repPageWidgets).includes(widgetId)) {
            delete newRepPageWidgets[widgetId];
            createNotification('Widget removed', NOTIFICATION_TYPES.SUCCESS);
        }

        dispatch(setRepPageWidgets(newRepPageWidgets));
    };

    const handleMoveWidgetUp = (
        metric,
        visualization,
        sortDirection,
        aggregationMetric
    ) => {
        const widgetId = widgetService.createWidgetRuleset(
            metric,
            visualization,
            sortDirection,
            perspective,
            aggregationMetric
        );

        let newRepPageWidgets = objectService.moveObjectItemUp(
            widgetId,
            repPageWidgets
        );

        if (
            !objectService.checkObjectKeysEqual(
                newRepPageWidgets,
                repPageWidgets
            )
        ) {
            dispatch(setRepPageWidgets(newRepPageWidgets));
        }
    };

    const handleDateChange = (date) => {
        localStorage.setItem('selectedDate', date);
        setSelectedDate(date);
    };

    const [repInfo, setRepInfo] = useState({});

    useEffect(() => {
        if (discoverSearchMaster['rep'][params.id]) {
            setRepInfo(discoverSearchMaster['rep'][params.id]);
        }
    }, [discoverSearchMaster, params.id]);

    useEffect(() => {
        if (Object.keys(repInfo).includes('code')) {
            setPerspective({
                code: repInfo['code'],
                descr: repInfo['name'],
                type: DISCOVER_WIDGET_AGGREGATION_METRICS.REP,
            });
        }
    }, [repInfo]);

    useEffect(() => {
        // dispatch(clearWidgets());
    }, [repPageWidgets]);

    return (
        <div
            className={`${discover_page} ${REACT_TOUR_CLASS_NAMES.DISCOVER_PAGE}`}
        >
            <div className={`${discover_grid}`}>
                <DiscoverSubNavigation
                    title="Rep View"
                    widgets={repPageWidgets}
                    onDateChange={handleDateChange}
                    selectedDate={selectedDate}
                    className={`col-span-2 row-span-max sticky ${muted_border}`}
                />

                {objectService.checkObjectPopulated(repInfo) ? (
                    objectService.checkObjectPopulated(perspective) && (
                        <>
                            <Admin
                                type={DISCOVER_WIDGET_AGGREGATION_METRICS.REP}
                                data={repInfo}
                                className={widget_full}
                                handleRefresh={() =>
                                    setRefresher(refresher + 1)
                                }
                            />

                            {objectService.checkObjectPopulated(
                                repPageWidgets
                            ) &&
                                Object.keys(repPageWidgets).map(
                                    (widgetId, index) => {
                                        const widget = repPageWidgets[widgetId];

                                        return (
                                            <Widget
                                                id={widgetService.createWidgetRuleset(
                                                    widget.metric,
                                                    widget.visualization,
                                                    widget.sortDirection,
                                                    perspective,
                                                    widget.aggregationMetric
                                                )}
                                                key={widgetService.createWidgetRuleset(
                                                    widget.metric,
                                                    widget.visualization,
                                                    widget.sortDirection,
                                                    perspective,
                                                    widget.aggregationMetric
                                                )}
                                                perspective={perspective}
                                                metric={widget.metric}
                                                visualization={
                                                    widget.visualization
                                                }
                                                sortDirection={
                                                    widget.sortDirection
                                                }
                                                aggregationMetric={
                                                    widget.aggregationMetric
                                                }
                                                selectedDate={selectedDate}
                                                onDateChange={handleDateChange}
                                                size={widget.size}
                                                className={`${
                                                    widget.size === 'full'
                                                        ? widget_full
                                                        : widget_half
                                                } ${
                                                    index === 0 &&
                                                    REACT_TOUR_CLASS_NAMES.WIDGET_1
                                                }`}
                                                onRemoveWidget={
                                                    handleRemoveWidget
                                                }
                                                onMoveUp={handleMoveWidgetUp}
                                                daisyTheme={daisyTheme}
                                                refresher={refresher}
                                            />
                                        );
                                    }
                                )}
                        </>
                    )
                ) : (
                    <NotFound type={'Rep'} descr={params.id} />
                )}

                <AddWidget
                    perspective={perspective}
                    onAddWidget={handleAddWidget}
                />
            </div>
        </div>
    );
};

export default RepPage;